import { render } from "./category-levels-assessment-mobile-placeholder.vue?vue&type=template&id=228f422f&scoped=true&ts=true"
import script from "./category-levels-assessment-mobile-placeholder.vue?vue&type=script&lang=ts"
export * from "./category-levels-assessment-mobile-placeholder.vue?vue&type=script&lang=ts"

import "./category-levels-assessment-mobile-placeholder.vue?vue&type=style&index=0&id=228f422f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228f422f"]])

export default __exports__